import { useState } from 'react';
import FeedbackModal from './components/FeedbackModal';
import ImageUpload from './components/ImageUpload';
import IntroVideo from './components/IntroVideo';
import ResultsGrid from './components/ResultsGrid';
import { assetUrl } from './utils/imageUrls';

function App() {
  const [results, setResults] = useState([]);

  return (
    <>
      <div
        className="app-background"
        style={{ backgroundImage: `url("${assetUrl('back-ground-copy.jpg')}")` }}
      />
      {/* <IntroVideo /> */}
      <main className="page-shell">
        <section className="search-panel">
          <div className="gallery-note"><span>Welcome to Vision Studio</span></div>
          <div className="subtitle">
            <h1>Find Your Memorable Moments with Ease</h1>
            <p>A unique and effortless way to discover your event photos.</p>
          </div>
          <p className="highlight-text">You're in the right place!</p>
          <p className="main-instruction">
            <span>
              Take a selfie or upload a photo to quickly locate your moments{' '}
              <i className="fa-solid fa-turn-down" />
            </span>
          </p>

          <ImageUpload onResultsChange={setResults} />
          <ResultsGrid results={results} />
        </section>
      </main>
      <FeedbackModal />
      <footer className="footer">
        &copy; 2026 Vision Studio - Powered by vision technology
      </footer>
    </>
  );
}

export default App;
